import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  copy(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const content = button.dataset.clipboardContent;

    navigator.clipboard
      .writeText(content)
      .then(() => {
        button.setAttribute("data-copied", true);

        // remove copied data attribute after 2 seconds
        setTimeout(() => button.removeAttribute("data-copied"), 2000);
      })
  }
}
